import type { Risk } from '@src/types';

export const evenRisk = (element: Risk) =>
  element.binding === true && element.active === true;
